import {BaseEntityConfig, WhiteListFields} from '~/redux/base-entity-config';
import {UserEntity} from '~/redux/users/types';

class EntityConfig extends BaseEntityConfig<UserEntity> {
  entityKey = 'users';

  associates = [];

  whiteListFields: WhiteListFields<UserEntity> = ['*'];

  getAccessors = (value: UserEntity) => {
    value.$avatarPlaceholder = value?.preferredName || value?.name || value?.email || '';
    value.$displayName = value.preferredName || value.name || value.email || '';
    value.$roleName = value.roles?.[0]?.name || 'User';
    value.$role = value.roles?.[0];
  };
}

const userEntConf = new EntityConfig();

export const userSchema = userEntConf.getEntitySchema();

export default userEntConf;

export const SOURCES_USER = {
  USERS_PAGE: 'USERS_PAGE',
  USERS_DROPDOWN: 'USERS_DROPDOWN',
};
